<nz-modal
  nzWrapClassName="form-modal2"
  [(nzVisible)]="isVisibleModal"
  [nzTitle]="modalTitle"
  [nzCentered]="true"
  [nzClassName]="'modal-m-t-30'"
  [nzContent]="modalContent"
  [nzFooter]="modalFooter"
  [nzMaskStyle]="{'background': 'rgba(255, 255, 255, 0.69)'}"
  (nzOnCancel)="onCloseModal(false)">
  <ng-template #modalTitle>
    <div class="container-steps-modal" [@fadeInAnimation]>
      <h2 class="text-title-md-bold title-modal">Seleccionar paciente</h2> <!-- Agregar pacientes -->
      <p class="text-info mt-xxs">Selecciona a un paciente para la cita</p><!-- Selecciona a los pacientes para participación como asistentes -->
      <!-- <i class="icon-add-user" nz-icon nzType="user-add" nzTheme="outline" nz-popover
        [nzPopoverContent]="'Agregar nuevo paciente'"
        (click)="this.showModalAddPatient= true"></i> -->

       
    </div>
  </ng-template>

  <ng-template #modalContent>
    <div class="mb-lg tw-flex flex-row	">
      <input class="tw-mr-2" type="text" nz-input placeholder="Buscar paciente por nombre" (keyup)="onSearch($event)" />
      <button
        class="  btn-default"
        (click)="this.showModalAddPatient = true"
        nz-button nzType="default">
      <i nz-icon nzType="user-add" nzTheme="outline"></i>
      Agregar nuevo paciente</button>
    </div>

    <div class="container-modal" [@fadeInAnimation]>
      <div nz-row [nzGutter]="16" *ngIf="(assistants$ | async) && (assistants$ | async)?.length> 0">
        <div class="mb-sm" nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="12" nzXl="8" nzXXl="6" *ngFor="let assistant of (assistants$ | async); index as
          i">
          <app-card-assistant
            class="tw-w-full assistant assistant-{{i}}"
            [name]="assistant.fullName"
            [gender]="assistant.gender"
            [imageProfile]="assistant.profileImageURL"
            [birthday]="assistant?.birthday"
            (selected)="onSelectAssistant(assistant)"
            [selectable]="assistant._id !== patientId"
            [disabled]="assistant._id === patientId"
            [active]="selectedAssistants.includes(assistant._id)"></app-card-assistant>
        </div>
      </div>
      <div nz-row [nzGutter]="16" *ngIf="(assistants$ | async) && (assistants$ | async)?.length === 0 && search === ''">
        <p>No hay más participantes por agregar.</p>
      </div>
      <div nz-row [nzGutter]="16" *ngIf="(assistants$ | async) && (assistants$ | async)?.length === 0 && search">
        <p>No hay coincidencias de búsqueda.</p>
      </div>
      <app-paginator *ngIf="(assistants$ | async) && (assistants$ | async)?.length> 0" class="pl-xxs" [configuration]="paginatorConfig" [total]="total$
        | async" [index]="indexPage" (change)="onChangePagination($event)"></app-paginator>
    </div>
  </ng-template>

  <ng-template #modalFooter>
    <div class="container-footer-modal" [@fadeInAnimation]>
      <button
        style="margin-right: 5px;"
        (click)="onCloseModal(false)"
        nz-button nzType="cancel">
        <i nz-icon nzType="close-circle" nzTheme="outline"></i>
        CANCELAR</button>
      <button
        class="btn-add-assistant"
        (click)="onCloseModal(true)"
        [disabled]="disableAddPatients"
        nz-button nzType="primary">
        <i nz-icon nzType="select" nzTheme="outline"></i>
        SELECCIONAR PARTICIPANTE</button> <!-- AÑADIR SELECCIONADOS -->
    </div>
  </ng-template>
</nz-modal>

<ng-container>
  <app-modal-create-patient
    [clinicId]="this.clinicId"
    [isVisibleModal]="this.showModalAddPatient"
    [onlyRegister]="true"
    (closeModal)="onCloseModalAddPatient($event)"></app-modal-create-patient>
</ng-container>
